
import axios from '@/axios.js'

export default {
  setPekerjaanSearchQuery ({ commit }, query) {
    commit('SET_PEKERJAAN_SEARCH_QUERY', query)
  },

  // Fetch filter
  fetchFilters ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-filter-pekerjaan/${payload}`)
        .then((response) => {
          commit('SET_FILTERS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addFilter ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post('/task-add-filter-pekerjaan', filter)
        .then((response) => {
          commit('ADD_FILTER', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  addTag ({ commit }, tag) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', tag)
        .then((response) => {
          commit('ADD_TAG', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  // Fetch pekerjaans
  fetchPekerjaans ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      //axios.get(`/task-list-pekerjaan/${payload.anggaranId}/${payload.search}/${payload.filter}`)
      axios.post('/task-list-pekerjaan', payload)
      .then((response) => {
        if (payload.action === 'create') {
          commit('SET_PEKERJAANS', response.data.data.tasks)
          commit('SET_TAXONOMY', response.data.data.taxonomy)
          commit('SET_RAB', response.data.data.rab)
          commit('SET_TOTALS', response.data.data.total)
          commit('SET_LAST', response.data.data.last_page)
          commit('SET_PER_PAGE', response.data.data.per_page)
          commit('SET_CURRENT_PAGE', response.data.data.current_page)
        } else {
          for (let i = 0; i < response.data.data.tasks.length; i++) {
            commit('PUSH_ANALISAS', response.data.data.tasks[i])
            commit('SET_CURRENT_PAGE', response.data.data.current_page)
          }
        }
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },

  addPekerjaan ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post('/task-add-pekerjaan', task)
        .then((response) => {
          commit('ADD_PEKERJAAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  updatePekerjaan ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post(`/task-update-pekerjaan/`, task)
        .then((response) => {
          commit('UPDATE_PEKERJAAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  // Fetch Tags
  fetchTags ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-tags-pekerjaan/${payload}`)
        .then((response) => {
          commit('SET_TAGS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  setLabels ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/task-tags-set-pekerjaan', payload)
      .then((response) => {
        commit('SET_LABELS', payload)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },

  deletePekerjaan ({ commit }, taskId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/task-delete-pekerjaan/${taskId}`)
        .then((response) => {
          commit('REMOVE_PEKERJAAN', taskId)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  deletesPekerjaan ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/task-deletes-pekerjaan', { pekerjaanIds: payload.pekerjaans })
      .then((response) => {
        let load = { pekerjaans: payload.pekerjaans }
        commit('REMOVES_PEKERJAAN', load)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },

  putbackPekerjaan ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post('/task-restore-pekerjaan', task)
        .then((response) => {
          commit('RESTORE_PEKERJAAN', task.pekerjaanId)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  // Move pekerjaans to another folder
  movePekerjaanTo ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.to === 'trash') {
        axios.post('/task-deletes-pekerjaan/', payload.pekerjaanIds)
        .then((response) => {
          commit('MOVE_PEKERJAANS_TO', payload)
          //commit('UPDATE_UNREAD_META_ON_MOVE', payload)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      }
    })
  },

  // Update Pekerjaans label
  updateLabels ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/task-tags-sets-pekerjaan', { pekerjaanIds: payload.pekerjaans, label: payload.label })
      .then((response) => {
        let load = { pekerjaans: payload.pekerjaans, label: response.data.data }
        commit('UPDATE_LABELS', load)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
}
